<template>
  <div class="techCase">
    <CommonLayout>
      <div slot="header">
        <h3>平台动态</h3>
      </div>
      <div slot="container">
        <div class="techCase-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
            style="background: #623AA2;border: none;"
          >
            新增
          </el-button>
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
          <div class="selectType">
            <span>类型：</span>
            <el-select v-model="type" placeholder="请选择" clearable @change="selectType">
              <el-option label="全部" value></el-option>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div id="table">
          <!--动态绑定长宽-->
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            type="index"
            :header-cell-style="headerStyle"
          >
            <el-table-column type="index" width="100" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (currentPage - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="标题" align="center"></el-table-column>
            <el-table-column prop="content" label="内容" align="center"></el-table-column>
            <el-table-column prop="type" label="类型" align="center" width="100">
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.type == 1
                      ? '通知公告'
                      : scope.row.type == 2
                      ? '政策法规'
                      : scope.row.type == 3
                      ? '动态资讯'
                      : ''
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="published" label="是否发布" align="center" width="100">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.published == 2">已发布</el-tag>
                <el-tag type="info" v-else>未发布</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="popular" label="热门推荐" align="center" width="100">
              <template slot-scope="scope">
                <el-tag type="danger" v-if="scope.row.popular == 2">已推荐</el-tag>
                <el-tag type="info" v-else>未推荐</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="380">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="preview(scope.row)"
                    v-if="scope.row.published == 1"
                  >
                    确定发布
                  </el-button>
                  <el-button size="mini" type="warning" @click="preview(scope.row)" v-else>
                    取消发布
                  </el-button>
                  <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
                    删除
                  </el-button>
                  <el-button
                    size="mini"
                    type="success"
                    @click="popular(scope.row)"
                    v-if="scope.row.popular == 1"
                  >
                    热门推荐
                  </el-button>
                  <el-button size="mini" type="info" @click="popular(scope.row)" v-else>
                    取消推荐
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="per_page"
          layout="total, prev, pager, next"
          :total="total"
          style="text-align:left;margin:20px 0"
        ></el-pagination>
      </div>
    </CommonLayout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      @closed="resetFn"
    >
      <el-form
        v-if="dialogFormVisible"
        :model="ruleForm"
        ref="ruleForm"
        label-width="75px"
        :rules="rules"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="ruleForm.title" clearable></el-input>
            </el-form-item>
            <el-form-item label="时间" prop="time">
              <el-date-picker
                v-model="ruleForm.time"
                :picker-options="pickerOptions"
                type="datetime"
                placeholder="选择日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="text-align: left;width:100%"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-select v-model="ruleForm.type" placeholder="请选择" clearable style="width:100%">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属区域" prop="address">
            <el-select v-model="ruleForm.region" style="width: 100%" 　clearable>
              <el-option
                v-for="item in cur_lives"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="封面" prop="cover">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
              >
                <img v-if="ruleForm.cover" :src="imgUrl + ruleForm.cover" class="img_border" />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !ruleForm.cover }"
                ></i>
                <span class="upload_btn" v-if="!ruleForm.cover">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="ruleForm.cover">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="content" style="margin-top:5px;">
          <!-- <editor :quill-data="ruleForm.content" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
          <editor
            v-model="ruleForm.content"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
          ></editor>
        </el-form-item>
        <el-form-item>
          <el-col :span="12">
            <el-form-item label="热门:" prop="popular" style="text-align:left">
              <el-switch
                v-model="ruleForm.popular"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
                :active-value="2"
                :inactive-value="1"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布:" prop="published" style="text-align:left">
              <el-switch
                v-model="ruleForm.published"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
                :active-value="2"
                :inactive-value="1"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item style="text-align:right">
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="closeForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import editor from "../../components/yhQuillEditor";
import { DisabledDateFn } from '../../../utils/tool';
import editor from '../../../components/tinymce-editor/tinymce-editor';
import CommonLayout from '../../../components/common-layout.vue';
export default {
  components: {
    editor,
    CommonLayout
  },
  data() {
    return {
      resetForm: '',
      pickerOptions: {
        disabledDate: this.disabledDateFn
      },
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE'
      },
      type: '',
      selected: '',
      searchValue: '',
      total: 10,
      per_page: 10,
      currentPage: 1,
      dialogFormVisible: false,
      cur_lives: [
        {
          id: '酒泉市',
          label: '酒泉市'
        },
        {
          id: '嘉峪关市',
          label: '嘉峪关市'
        },
        {
          id: '武威市',
          label: '武威市'
        },
        {
          id: '兰州市',
          label: '兰州市'
        },
        {
          id: '张掖市',
          label: '张掖市'
        },
        {
          id: '金昌市',
          label: '金昌市'
        },
        {
          id: '临夏回族自治州',
          label: '临夏回族自治州'
        },
        {
          id: '定西市',
          label: '定西市'
        },
        {
          id: '庆阳市',
          label: '庆阳市'
        },
        {
          id: '白银市',
          label: '白银市'
        },
        {
          id: '天水市',
          label: '天水市'
        },
        {
          id: '陇南市',
          label: '陇南市'
        },
        {
          id: '甘南藏族自治州',
          label: '甘南藏族自治州'
        },
        {
          id: '平凉市',
          label: '平凉市'
        }
      ],
      Title: '',
      tableData: [],
      options: [
        {
          value: 1,
          label: '通知公告'
        },
        {
          value: 2,
          label: '政策法规'
        },
        {
          value: 3,
          label: '动态资讯'
        }
      ],
      is_submit: true,

      ruleForm: {
        title: '',
        time: '',
        type: '',
        address: '',
        content: '',
        published: 2,
        popular: 1,
        cover: ''
      },
      rules: {
        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'change'
          }
        ],
        time: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'change'
          }
        ],
        content: [
          {
            required: true,
            message: '请输入内容',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {
    this.getData();
    this.resetFn(true);
  },
  methods: {
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    getData() {
      this.http
        .post('/apij2/admin-api/trade/platform-dynamics/page', {
          keyword: this.searchValue,
          type: this.type,
          page: this.current_page,
          pageSize: this.per_page
        })
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.per_page = res.data.per_page;
            this.total = res.data.total;
            this.currentPage = res.data.current_page;
            this.tableData.forEach(item => {
              item.content = this.GetTarg(item.content);
            });
          }
        });
    },
    resetFn(flag = false) {
      if (flag) {
        this.resetForm = JSON.stringify(this.ruleForm);
      } else {
        this.ruleForm = JSON.parse(this.resetForm);
      }
    },
    //新增
    add() {
      this.resetFn();
      this.ruleForm = {
        title: '',
        time: '',
        type: '',
        content: '',
        published: 2,
        popular: 1,
        cover: ''
      };
      this.is_submit = true;
      this.dialogFormVisible = true;
    },
    //编辑
    handleEdit(val) {
      this.is_submit = true;

      this.Title = '编辑';
      this.http.get(`/apij2/admin-api/trade/platform-dynamics/get?id=${val.id}`).then(res => {
        if (res.code == 0) {
          this.ruleForm = res.data;
          this.dialogFormVisible = true;
        }
      });
    },
    //提交
    submitForm(formName) {
      if (!this.is_submit) return;
      this.is_submit = false;
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = this.ruleForm;
          if (!obj.id) {
            this.http
              .post('/apij2/admin-api/trade/platform-dynamics/create', obj)
              .then(res => {
                if (res.code == 0) {
                  this.$message.success('新建成功');
                  this.getData();
                  this.dialogFormVisible = false;
                  this.ResetSearch(['searchValue', 'type']);
                  this.$refs[formName].resetFields();
                } else {
                  this.$message.error(res.status);
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          } else {
            this.http
              .post('/apij2/admin-api/trade/platform-dynamics/update', obj)
              .then(res => {
                if (res.code == 0) {
                  this.$message.success('编辑成功');
                  this.getData();
                  this.dialogFormVisible = false;
                  this.ResetSearch(['searchValue', 'type']);

                  this.$refs[formName].resetFields();
                } else {
                  this.$message.error(res.status);
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;

          // console.log("校验失败")
          // this.resetFn()
          return false;
        }
      });
    },
    //取消
    closeForm(formName) {
      this.dialogFormVisible = false;
      //   this.$refs[formName].resetFields();
      // this.resetFn()
    },
    //发布
    preview(e) {
      let data = {
        ...e
      };
      if (e.published == 1) {
        data.published = 2;
      } else if (e.published == 2) {
        data.published = 1;
      }
      this.http.post('/apij2/admin-api/trade/platform-dynamics/update', data).then(res => {
        if (res.code == 0) {
          if (data.published == 2) {
            this.$message.success('发布成功');
          } else {
            this.$message.success('已取消发布');
          }
          this.getData();
        } else {
          this.$message.error(res.status);
        }
      });
    },
    //热门
    popular(e) {
      let data = { ...e };
      if (e.popular == 1) {
        data.popular = 2;
      } else if (e.popular == 2) {
        data.popular = 1;
      }
      this.http.post('/apij2/admin-api/trade/platform-dynamics/update', data).then(res => {
        if (res.code == 0) {
          if (data.popular == 1) {
            this.$message.success('已取消推荐');
          } else {
            this.$message.success('推荐成功');
          }
          this.getData();
        } else {
          this.$message.error(res.status);
        }
      });
    },
    //搜索
    search() {
      this.getData();
    },
    selectType() {
      this.getData();
    },
    //删除
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.http
            .request(`/apij2/admin-api/trade/platform-dynamics/delete?id=${row.id}`, '', 'delete')
            .then(res => {
              if (res.code == 0) {
                this.ResetSearch(['searchValue', 'type']);

                this.searchValue = '';
                this.type = '';
                this.getData();
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
              } else {
                this.$message({
                  message: '失败！',
                  type: 'error'
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },

    //翻页
    handleCurrentChange(val) {
      this.getData();
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, 'HouImg');
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960
      })
        .then(rst => {
          this.http
            .post('/file/base64_upload', {
              image: rst.base64
            })
            .then(res => {
              this.ruleForm.cover = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },

    handlePictureCardPreview(file) {
      this.ruleForm.cover = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.ruleForm.cover;
      img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.ruleForm.cover = '';
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.techCase {
  width: 100%;
  height: 100%;
  .techCase-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;

    // margin-top: 20px;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }

    .selectType {
      display: inline-block;
    }
  }

  #table {
    margin-top: 20px;
    border: 1px solid #eef1f6;

    /deep/ th {
      // background-color: #eef1f6 !important;
      // color: #000;
    }

    /deep/ td {
    }

    /deep/ .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .blue {
      color: #47eb0d;
    }

    .red {
      color: red;
    }
  }
}

/*上传图片*/
.is_border {
  border: 1px dashed #ddd !important;
  border-radius: 5px;
  height: 154px !important;
  line-height: 154px !important;
}

.upload_btn {
  display: block;
  background-color: #00a1ff;
  font-weight: bold;
  color: #fff;
  padding: 2px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.upload_btn:hover {
  background-color: #13ce66;
}

.del_img {
  position: absolute;
  top: -7px;
  left: 224px;
  color: #00a1ff;
}

.del_img:hover {
  cursor: pointer;
  color: #f00;
}

.del_img i:before {
  font-size: 20px;
}

.img_border {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  width: 243px;
  height: 154px;
  display: block;
}

.avatar-uploader {
  text-align: center;
  width: 243px;
  height: 178px;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 154px;
  line-height: 154px;
  text-align: center;
}

/deep/ .yh-quill-editor {
  .el-upload {
    display: none;
  }

  .ql-toolbar {
    text-align: left;
  }
}
</style>
